import React, { useMemo } from 'react';
import classnames from 'classnames';
import { SelectOption } from 'tea-component';
import { renderImgText } from '@intelligence/components/TeaSelector/MultipleSelector';
import GeneralSelect from '@/pages/aigc/pages/MotionCapture/components/GeneralSelect';

import type { IGame, IFilter } from '../../types';

interface IFilterProps {
  games: IGame[];
  value: IFilter;
  onChange: (value: IFilter) => void;
  className?: string;
  style?: React.CSSProperties;
}

const Filter: React.FC<IFilterProps> = (props) => {
  const { games, value, onChange, className, style } = props;

  const gamesOptions = useMemo<SelectOption[]>(() => {
    if (!Array.isArray(games)) return [];
    return games.map((game) => ({
      text: renderImgText(game?.name, game?.cover),
      value: game?.id,
    }));
  }, [games]);

  const handleGameChange = (game: string) => {
    const valueTmp = {
      ...value,
      role_model_type: game,
    };
    onChange(valueTmp);
  };

  return (
    <div className={classnames('dba-motion-capture__filter', className)} style={style}>
      <GeneralSelect
        label="aigc_common_game"
        options={gamesOptions}
        value={value?.role_model_type}
        onChange={handleGameChange}
      />
    </div>
  );
};

export default Filter;
